import {
    CREATE_ASSESSMENT,
    CREATE_ASSESSMENT_SUCCESS,
    GET_ALL_ASSESSMENTS,
    SET_ALL_ASSESSMENTS,
    GET_ASSESSMENT_BY_ID,
    SET_ASSESSMENT_BY_ID,
    ACTIVATE_ASSESSMENT,
    SET_ACTIVATE_ASSESSMENT_SUCCESS
} from "./AssessmentTypes"

const createAssessment = (assessment: any) => ({
    type: CREATE_ASSESSMENT,
    assessment
});

const setAssessmentCreationSuccess = (flag: any) => ({
    type: CREATE_ASSESSMENT_SUCCESS,
    flag
})

const getAllAssessments = (id?: any) => {
    return {
        type: GET_ALL_ASSESSMENTS,
        id
    }
}

const setAllAssessments = (assessmentsList: any) => ({
    type: SET_ALL_ASSESSMENTS,
    assessmentsList
})

const getAssessmentById = (id: any) => {
     return {
        type: GET_ASSESSMENT_BY_ID,
        id
    }
}

const setAssessmentById = (assessmentById: any) => {
    return {
        type: SET_ASSESSMENT_BY_ID,
        assessmentById
    }
}

const activateAssessment = (assessment: any) => {
    return {
        type: ACTIVATE_ASSESSMENT,
        assessment
    }
}

const setAssessmentActivateSuccess = (flag: any) => ({
    type: SET_ACTIVATE_ASSESSMENT_SUCCESS,
    flag
})

export {
    createAssessment,
    setAssessmentCreationSuccess,
    getAllAssessments,
    setAllAssessments,
    getAssessmentById,
    setAssessmentById,
    activateAssessment,
    setAssessmentActivateSuccess
}